import { motion } from 'framer-motion'
import { useState } from 'react'
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md'
import { useQuery } from 'react-query'
import { useMediaQuery } from 'react-responsive'
import { Swiper, SwiperSlide } from 'swiper/react'
import { GET_CUSTOMER_REVIEWS } from '~src/api'
import { graphQLClient } from '~src/api/graphql'
import TitleAni from './TitleAni'

export const CustomerRate = () => {
  let isOrTablet = useMediaQuery({ query: '(max-width: 1200px)' })
  let isOrMobile = useMediaQuery({ query: '(max-width: 800px)' })
  let isOrMobileSmall = useMediaQuery({ query: '(max-width: 500px)' })

  // GET_CONTENT_HOME_PAGE
  const { data: dataCustomerReviews, isLoading: isLoadingDataCustomerReviews } = useQuery({
    queryKey: ['getDataCustomerReviews'],
    queryFn: async () => {
      const data: any = await graphQLClient.request(GET_CUSTOMER_REVIEWS, {
        currentPage: 1,
        pageSize: 999,
      })
      return data?.getCustomerReviews?.items ?? []
    },
    cacheTime: Infinity,
  })

  const [swiper, setSwiper] = useState<any>(null)
  const handleNext = () => {
    swiper.slideNext()
  }

  const handlePrev = () => {
    swiper.slidePrev()
  }

  // useEffect(() => {
  //   gsap.registerPlugin(ScrollTrigger);
  //   const title = document.querySelector(".customer-rate .title");
  //   gsap.set(title, { opacity: 0, y: 100 });
  //   ScrollTrigger.create({
  //     trigger: title,
  //     start: "top 80%",
  //     end: "top 30%",
  //     onEnter: () => {
  //       gsap.to(title, {
  //         opacity: 1,
  //         y: 0,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //     onLeaveBack: () => {
  //       gsap.to(title, {
  //         opacity: 0,
  //         y: 100,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //   });
  // }, []);

  // useEffect(() => {
  //   gsap.registerPlugin(ScrollTrigger);
  //   const title = document.querySelector(".swiper-customer-rate");
  //   gsap.set(title, { opacity: 0, x: 100 });
  //   ScrollTrigger.create({
  //     trigger: title,
  //     start: "top 80%",
  //     end: "top 30%",
  //     onEnter: () => {
  //       gsap.to(title, {
  //         opacity: 1,
  //         x: 0,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //     onLeaveBack: () => {
  //       gsap.to(title, {
  //         opacity: 0,
  //         x: 100,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //   });
  // }, []);
  if (dataCustomerReviews?.length === 0 || isLoadingDataCustomerReviews) return null
  return (
    <div className="customer-rate">
      <div className="bg-otp">
        <motion.div
          className="img"
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
        >
          <img src="/image/otpcom.png" alt="" />
        </motion.div>
      </div>
      <div className="img-position">
        <motion.img
          src="/image/11.png"
          alt=""
          animate={{ y: [-8, 8, -8], rotate: [-2, 2, -2] }}
          transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        />
      </div>
      <div className="title">
        <div className="icon-center icon-brand mx-auto">
          <img src="/image/ic-brand.svg" alt="" />
        </div>
        <TitleAni title="ĐÁNH GIÁ KHÁCH HÀNG"></TitleAni>
      </div>
      <div className="content-customer-rate">
        <div className="layer-car">
          <div className="img">
            <img src="/image/layer-car.png" alt="" />
          </div>
        </div>
        <div className="elip">
          <div className="img">
            <img src="/image/elip.png" alt="" />
          </div>
        </div>
        <div className="arrow-group z-10">
          <div className="arrow-button prev">
            <div className="icon icon-prev" onClick={handlePrev}>
              <MdOutlineKeyboardArrowLeft />
            </div>
          </div>
          <div className="arrow-button next">
            <div className="icon icon-next" onClick={handleNext}>
              <MdOutlineKeyboardArrowRight />
            </div>
          </div>
        </div>
        <div>
          {dataCustomerReviews?.length > 0 && (
            <Swiper
              slidesPerView={isOrMobileSmall ? 1.5 : isOrMobile ? 2.5 : isOrTablet ? 3.5 : 4.5}
              slidesPerGroup={1}
              initialSlide={Math.ceil((dataCustomerReviews?.length ?? 0) / 2)}
              spaceBetween={isOrMobileSmall ? 4 : isOrMobile ? 24 : 100}
              centeredSlides={true}
              onSwiper={(s: any) => {
                setSwiper(s)
              }}
              allowTouchMove={true}
              loop={true}
              slideToClickedSlide={true}
              //@ts-ignore
              lazy={true}
              speed={1000}
            >
              {dataCustomerReviews?.map((item: any, index: number) => {
                return (
                  <SwiperSlide key={index}>
                    <div className={`item-slide`}>
                      <div className="inner-item">
                        <div className="content-inner">
                          <div className="icon">
                            <img src="/icons/Quote.svg" alt="" />
                          </div>
                          <div
                            className="description in-4-line"
                            dangerouslySetInnerHTML={{
                              __html: item?.content,
                            }}
                          ></div>
                          <div className="info-inner">
                            <div className="name">{item?.customer_name}</div>
                            <div className="note">{item?.job}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  )
}
